.card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 18px 18px;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
}

.group {
  display: flex;
  flex-direction: column;
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.legend {
  margin-bottom: 10px;
  padding: 0;
  font-size: 18px;
  font-weight: 700;
}

/* Three equal segments, as drawn on the blueprint's Settings board. */
.options {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
}

.option {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--surface);
  box-shadow: 2px 2px 0 var(--ink);
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}

/* The chosen segment is filled with ink and drops its shadow: a change of
 * lightness and shape, so the choice never rests on hue alone. */
.option:has(:checked) {
  background: var(--ink);
  color: var(--bg);
  box-shadow: none;
}

/* The hidden radio cannot show the page's focus ring, so its segment does. */
.option:has(:focus-visible) {
  outline: 3px solid var(--ink);
  outline-offset: 2px;
}

/* The radio stays in the page for the keyboard and assistive technology; the
 * segment it sits in is what shows it. */
.radio {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.hint {
  font-size: 13px;
  line-height: 1.45;
  color: var(--ink-3);
}

.error {
  padding: 8px 10px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--error-soft);
  font-size: 14px;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.again {
  min-height: 44px;
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  font-weight: 700;
  color: var(--ink);
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}
